import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "nav-bar"

  connect() {
    super.connect()

    const title = this.bridgeTitle
    if (title) {
      this.send("connect", { title })
    }
  }

  get bridgeTitle() {
    return this.element.dataset.bridgeNavBarTitleValue ||
           document.querySelector("[data-page-title]")?.textContent?.trim() ||
           document.title
  }
}
